import { Middleware } from 'redux';
import { SUCCESS } from 'redux-and-the-rest';

import configureRequestAuthToken from '../reducers/utils/configureRequestAuthToken';
import { userActions } from '../reducers/userReducer';

/**
 * Middleware to set the authentication token to RATR global config
 */
const setAuthConfig: Middleware = () => (next) => (action) => {
  if ([userActions.createItem, userActions.fetchItem].includes(action.type) && action.status === SUCCESS) {
    const { item: { values: { authenticationToken } } } = action;

    configureRequestAuthToken(authenticationToken);
  }

  next(action);
};

export default setAuthConfig;
